import { render, staticRenderFns } from "./addTypeDialog.vue?vue&type=template&id=3ebb1b88&scoped=true"
import script from "./addTypeDialog.vue?vue&type=script&lang=js"
export * from "./addTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./addTypeDialog.vue?vue&type=style&index=0&id=3ebb1b88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebb1b88",
  null
  
)

export default component.exports